/**
 * Wear by Anaya — deep GA4 analytics
 * Custom page context + button / CTA / cart / wishlist / newsletter events.
 */
(function () {
  var ctx = {};
  try {
    var node = document.getElementById('anaya-analytics-context');
    if (node && node.textContent) ctx = JSON.parse(node.textContent);
  } catch (e) {
    ctx = {};
  }

  var measurementId = ctx.measurementId || '';
  if (!measurementId) return;

  function track(eventName, params) {
    if (typeof window.gtag !== 'function') return;
    var payload = Object.assign(
      {
        send_to: measurementId,
        page_type: ctx.pageType || '',
        template: ctx.template || '',
        page_path: ctx.path || location.pathname,
      },
      params || {}
    );
    window.gtag('event', eventName, payload);
  }

  function textOf(el) {
    if (!el) return '';
    return (el.getAttribute('aria-label') || el.textContent || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, 120);
  }

  function closestTrackable(target) {
    if (!target || !target.closest) return null;
    return target.closest(
      [
        '[data-anaya-track]',
        'button',
        'a.button',
        'a.anaya-menu__link',
        '.anaya-footer__links a',
        '.anaya-footer__form button',
        '[name="add"]',
        'add-to-cart-component button',
        'product-form-component button[type="submit"]',
        '.anaya-quick-add-drawer__submit',
        '[data-anaya-quick-add-submit]',
        '.anaya-wishlist-btn',
        '[data-anaya-wishlist]',
        'cart-icon-button',
        '[href*="/cart"]',
        '[href*="/checkout"]',
        '.anaya-pdp-size-guide__label',
        '.popup-link__button',
        'summary',
      ].join(',')
    );
  }

  function classify(el) {
    if (!el) return null;

    var forced = el.getAttribute('data-anaya-track');
    if (forced) {
      return {
        event: forced,
        label: el.getAttribute('data-anaya-track-label') || textOf(el),
        category: el.getAttribute('data-anaya-track-category') || 'custom',
      };
    }

    var href = (el.getAttribute('href') || '').toLowerCase();
    var label = textOf(el);
    var labelLower = label.toLowerCase();
    var className = typeof el.className === 'string' ? el.className : '';

    if (
      el.matches('[name="add"], add-to-cart-component button, product-form-component button[type="submit"]') ||
      /add to (bag|cart)/i.test(label)
    ) {
      return { event: 'add_to_cart', label: label || 'Add to bag', category: 'ecommerce' };
    }

    if (
      el.matches('.anaya-quick-add-drawer__submit, [data-anaya-quick-add-submit]') ||
      /quick add/i.test(label)
    ) {
      return { event: 'add_to_cart', label: label || 'Quick add', category: 'ecommerce', method: 'quick_add' };
    }

    if (el.matches('.anaya-wishlist-btn, [data-anaya-wishlist]') || /wishlist/i.test(labelLower)) {
      return { event: 'add_to_wishlist', label: label || 'Wishlist', category: 'engagement' };
    }

    if (href.indexOf('/checkout') !== -1 || /checkout/i.test(labelLower)) {
      return { event: 'begin_checkout', label: label || 'Checkout', category: 'ecommerce' };
    }

    if (
      el.matches('cart-icon-button') ||
      href.indexOf('/cart') !== -1 ||
      /^(cart|bag)$/i.test(labelLower)
    ) {
      return { event: 'view_cart', label: label || 'Cart', category: 'ecommerce' };
    }

    if (el.closest('.anaya-footer__form') && (el.matches('button[type="submit"]') || el.type === 'submit')) {
      return { event: 'generate_lead', label: label || 'Newsletter subscribe', category: 'newsletter' };
    }

    if (
      el.matches('.anaya-pdp-size-guide__label, .popup-link__button') ||
      /size guide/i.test(labelLower)
    ) {
      return { event: 'select_content', label: label || 'Size Guide', category: 'product', content_type: 'size_guide' };
    }

    if (el.matches('summary') || /^(details|care instructions|faqs?)/i.test(labelLower)) {
      return { event: 'select_content', label: label, category: 'accordion', content_type: 'expand' };
    }

    if (el.closest('.anaya-footer__links')) {
      return { event: 'select_content', label: label, category: 'footer_nav', link_url: href };
    }

    if (el.matches('a.anaya-menu__link') || el.closest('.anaya-menu')) {
      return { event: 'select_content', label: label, category: 'main_nav', link_url: href };
    }

    if (el.matches('a.button, button.button, .button') || className.indexOf('button') !== -1) {
      return { event: 'cta_click', label: label || 'Button', category: 'cta', link_url: href };
    }

    if (el.tagName === 'A' && href) {
      return { event: 'click', label: label, category: 'link', link_url: href };
    }

    if (el.tagName === 'BUTTON') {
      return { event: 'cta_click', label: label || 'Button', category: 'button' };
    }

    return null;
  }

  function productItemParams() {
    var p = ctx.product || {};
    if (!p.id) return {};
    var price = parseFloat(String(p.price || '').replace(/[^0-9.]/g, '')) || undefined;
    return {
      currency: ctx.currency || 'GBP',
      value: price,
      items: [
        {
          item_id: String(p.variantId || p.id),
          item_name: p.title || '',
          item_brand: p.vendor || '',
          item_category: p.type || ctx.collection || '',
          item_variant: p.sku || '',
          price: price,
          quantity: 1,
        },
      ],
    };
  }

  function sendClassification(info, el) {
    if (!info) return;

    var params = {
      event_category: info.category || '',
      event_label: info.label || '',
      link_url: info.link_url || el.getAttribute('href') || '',
      button_text: info.label || '',
    };

    if (info.method) params.method = info.method;
    if (info.content_type) params.content_type = info.content_type;

    if (info.event === 'add_to_cart' || info.event === 'add_to_wishlist' || info.event === 'begin_checkout') {
      Object.assign(params, productItemParams());
    }

    if (info.event === 'view_item' || info.event === 'view_cart') {
      Object.assign(params, productItemParams());
    }

    track(info.event, params);
  }

  // Enhanced page context for GA4 Explore / DebugView
  track('page_context', {
    page_type: ctx.pageType || '',
    template: ctx.template || '',
    collection: ctx.collection || '',
    product_id: (ctx.product && ctx.product.id) || '',
    product_title: (ctx.product && ctx.product.title) || '',
    product_vendor: (ctx.product && ctx.product.vendor) || '',
  });

  if (ctx.pageType === 'product' && ctx.product && ctx.product.id) {
    track('view_item', productItemParams());
  }

  if (ctx.pageType === 'collection' && ctx.collection) {
    track('view_item_list', {
      item_list_id: ctx.collection,
      item_list_name: ctx.collection,
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var el = closestTrackable(event.target);
      if (!el) return;
      // Avoid double-firing when clicking nested icons/spans
      if (el.closest('[data-anaya-track-ignore]')) return;
      sendClassification(classify(el), el);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.matches) return;

      if (form.matches('.anaya-footer__form, form[action*="contact"]')) {
        track('generate_lead', {
          event_category: 'newsletter',
          event_label: 'Newsletter form submit',
          method: 'footer',
        });
      }

      if (form.matches('form[action*="/cart/add"], product-form-component form')) {
        track('add_to_cart', Object.assign({ event_category: 'ecommerce', event_label: 'Product form submit' }, productItemParams()));
      }

      if (form.matches('form[action*="/search"], predictive-search form, .search-modal form')) {
        var input = form.querySelector('input[type="search"], input[name="q"]');
        track('search', {
          event_category: 'search',
          search_term: input ? input.value : '',
        });
      }
    },
    true
  );

  // Cart drawer / line updates from theme
  document.addEventListener('shopify:cart:lines-update', function () {
    track('cart_updated', {
      event_category: 'ecommerce',
      event_label: 'Cart lines update',
    });
  });
})();
